import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight, CheckCircle2 } from 'lucide-react'
import Logisticsteam from '../assets/images/data/Representative-parcel.png'

export default function CTA () {
  return (
    <section className='w-full bg-[#f8f9fb] overflow-hidden'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_340px] gap-8 lg:gap-12 items-center'>
          {/* LEFT CONTENT */}
          <div className='max-w-2xl z-10 py-10 sm:py-12 lg:py-14'>
            {/* HEADING */}
            <h2 className='text-2xl sm:text-3xl lg:text-[32px] font-bold text-[#211f57] leading-[1.12] tracking-tight'>
              Connecting India Through{' '}
              <span className='text-[#d32c30]'>Smarter Logistics</span>
            </h2>

            {/* FEATURES */}
            <div className='mt-6 flex flex-wrap items-center gap-x-5 gap-y-3 text-xs sm:text-sm text-gray-500'>
              <span className='flex items-center gap-2'>
                <CheckCircle2 size={16} className='text-green-600 shrink-0' />
                Pan-India Network
              </span>

              <span className='flex items-center gap-2'>
                <CheckCircle2 size={16} className='text-green-600 shrink-0' />
                Integrated Logistics
              </span>

              <span className='flex items-center gap-2'>
                <CheckCircle2 size={16} className='text-green-600 shrink-0' />
                Shipment Tracking
              </span>
            </div>

            {/* DESCRIPTION */}
            <p className='mt-5 text-sm sm:text-base lg:text-lg leading-7 sm:leading-7 text-gray-500 max-w-xl'>
              Deliver faster, smarter, and more reliably across India. Partner
              with S Infinite Express for integrated logistics solutions
              designed to support your business at every step.
            </p>

            {/* ACTION BUTTONS */}
            <div className='mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3'>
              {/* GET A QUOTE */}
              <Link
                to='/get-a-quote'
                className='inline-flex justify-center items-center gap-2 px-6 py-3.5
                bg-[#FFF44F] text-[#211f57] font-semibold text-sm sm:text-base
                shadow-md hover:bg-yellow-300 hover:-translate-y-0.5
                transition-all duration-300 whitespace-nowrap'
              >
                Get a Quote
                <ArrowRight size={18} />
              </Link>

              {/* TRACK SHIPMENT */}
              <Link
                to='/track-shipment'
                className='inline-flex justify-center items-center gap-2 px-6 py-3.5
                bg-[#211f57] text-white font-semibold text-sm sm:text-base
                shadow-md hover:bg-[#d32c30] hover:-translate-y-0.5
                transition-all duration-300 whitespace-nowrap'
              >
                Track a Package
                <ArrowRight size={18} />
              </Link>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className='relative w-full h-[280px] sm:h-[340px] md:h-[380px] lg:h-[415px] flex justify-center lg:justify-end overflow-hidden'>
            <img
              src={Logisticsteam}
              alt='S Infinite Express logistics team'
              loading='lazy'
              decoding='async'
              className='h-full w-full max-w-[340px] sm:max-w-[400px] lg:max-w-full
      object-contain object-bottom'
            />
          </div>
        </div>
      </div>
    </section>
  )
}
